import { ExpiryAlertGroup, ExpiryAlertGroupResponse, ExpiryAlerts, ExpiryAlertsResponse } from 'domain/notification';

const expiryAlertGroupMapper = ({ count, lots }: ExpiryAlertGroupResponse): ExpiryAlertGroup => ({
  count: Number(count),
  lots: lots.map((lot) => ({
    id: lot.id,
    code: lot.code,
    productName: lot.product_name,
    expiryDate: lot.expiry_date,
    daysLeft: Number(lot.days_left),
    stock: Number(lot.stock),
  })),
});

export const expiryAlertsMapper = (response: ExpiryAlertsResponse): ExpiryAlerts => ({
  expiringSoon: expiryAlertGroupMapper(response.expiring_soon),
  expired: expiryAlertGroupMapper(response.expired),
  expiringSoonDays: Number(response.expiring_soon_days),
});
